/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";

import * as crud from "../../../../app/pages/CatalogProducts/operations"
import { useSelector } from "react-redux";

export function AdvanceTablesWidget4({ className }) {
  const { user } = useSelector(state => state.auth);
  const userDocument = user.uid ? user : user.payload

  const [products, setProducts] = useState([])
  useEffect(() => {
    crud.getAll().then(({ data }) => {
      setProducts(data.payload)
    })
  }, [])
  return (
    <div className={`card card-custom ${className}`}>
      {/* Head */}
      <div className="card-header border-0 py-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">Products</span>
        </h3>
        {/* <div className="card-toolbar">
            <a href="#" className="btn btn-info font-weight-bolder font-size-sm mr-3">See Products</a>
            <a href="#" className="btn btn-danger font-weight-bolder font-size-sm">Create</a>
          </div> */}
      </div>
      {/* Body */}
      <div className="card-body pt-0 pb-3">
        <div className="tab-content">
          <div className="table-responsive">
            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
              <thead>
                <tr className="text-left text-uppercase">
                  <th className="pl-7" style={{ minWidth: "250px" }}><span className="text-dark-75">Product</span></th>
                  <th style={{ minWidth: "100px" }}>Cost</th>
                  <th style={{ minWidth: "100px" }}>Price</th>
                  <th style={{ minWidth: "100px" }}>Volume</th>
                  <th style={{ minWidth: "80px" }} >Category</th>
                </tr>
              </thead>
              <tbody>
                {products
                  .filter(row => row.client === userDocument.company_id)
                  .slice(0, 4)
                  .map((product, key) => {
                    return (
                      <tr key={key}>
                        <td className="pl-0 py-8">
                          <div className="d-flex align-items-center">
                            <div className="symbol symbol-50 symbol-light mr-4">
                              <span className="symbol-label">
                                <span className="svg-icon h-75 align-self-end">
                                  <img
                                    className="image-fluid rounded"
                                    height="100%"
                                    width="100%"
                                    src={product.image || process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE}
                                    alt="alternative"
                                  />
                                </span>
                              </span>
                            </div>
                            <div>
                              <span onClick={() => {

                              }}
                                className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{product.name}</span>
                              <span className="text-muted font-weight-bold d-block">{product.manufacture}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                            ${product.cost}
                          </span>
                          <span className="text-muted font-weight-bold">
                          </span>
                        </td>
                        <td>
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                            ${product.price}
                          </span>
                          <span className="text-muted font-weight-bold">

                          </span>
                        </td>
                        <td>
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                            {product.volume} {product.metric}
                          </span>
                          <span className="text-muted font-weight-bold">
                          </span>
                        </td>

                        <td className="pr-0 text-right">
                          <span className="btn btn-light-success font-weight-bolder font-size-sm">{product.category}</span>
                        </td>
                      </tr>

                    )
                  })}

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}